import { render } from "./App.vue?vue&type=template&id=1a7b1a4a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1a7b1a4a&lang=css"

import exportComponent from "/Users/ran/Development/temp/invitee-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__